import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { useEffect } from "react";
import $ from "jquery";
import { connect, useSelector } from "react-redux";
import ReassuranceSection from "./ReassuranceSection";

window.$ = window.jQuery = $;

// Resolve the API lang_id from the route language (first URL segment).
// URLs without a language prefix are English. Returns undefined until
// the language list is available.
export function useRouteLangId() {
  const { pathname } = useLocation();
  const languages = useSelector((s) => s.languages?.languages);

  if (!languages?.length) return undefined;

  const firstSegment = String(pathname.split("/").filter(Boolean)[0] || "").toLowerCase();
  const language =
    languages.find((item) => item.code === firstSegment) ||
    languages.find((item) => item.code === "en");

  return language?.id;
}

function Layout(props) {
const reassurance = props?.data?.reassurance_blocks || [];


const headerTop = reassurance.filter(
  i => i.header_position === "above_header"
);

const headerBottom = reassurance.filter(
  i => i.header_position === "below_header"
);

const footerBottom = reassurance.filter(
  i => i.footer_position === "below_footer"
);

// DEFAULT SLOT: above footer
const footerTop = reassurance.filter(i => {
  return (
    i.footer_position === "above_footer" ||
    (
      (i.header_position === "none" || !i.header_position) &&
      (i.footer_position === "none" || !i.footer_position)
    )
  );
});


  useEffect(() => {
    // Common content is fetched once per language by AppRoutes (App.js).
    let scrollFrame = 0;

    const handleScroll = () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(() => {
        document.querySelector(".header")?.classList.toggle("scrll", window.scrollY >= 10);
        scrollFrame = 0;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
    };

  }, []);

return (
  <>
  <ReassuranceSection items={headerTop} />


    <Header 
      data={props?.data?.header_menu} 
      site_settings={props?.data?.site_settings} 
      agc_menu={props?.data?.agc_header_menu}
      cart={props?.data?.cart}
    />
<ReassuranceSection
  items={headerBottom}
  reserveSpace={!props.commonLoaded}
/>
    <main className="site-main">
      <Outlet context={props?.data?.categories} />
    </main>
<ReassuranceSection items={footerTop} />


<Footer 
        data={props?.data?.footer_menu} 
        agc_footer_menu={props?.data?.footer_agc_menu}
        categories={props?.data?.footer_categories} 
        site_settings={props?.data?.site_settings}
      />
<ReassuranceSection items={footerBottom} />
    {/* Block the page only for the very first common-content load. */}
    {props.loader && !props.commonLoaded && (
      <div
        className="position-fixed top-0 start-0 w-100 vh-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-25"
        style={{ zIndex: 99999 }}
      >
        <div className="spinner-border text-light" role="status" />
      </div>
    )}
  </>
);
}

const mapStateToProps = state => {
  return {
    data: state.home.common_data,
    loader: state.home.common_loader,
    commonLoaded: state.home.common_loaded,
  };
};

export default connect(mapStateToProps)(Layout);
